import { createFileRoute, useParams } from '@tanstack/react-router';

import { HStack, Spacer, VStack } from '@/components/Layout';
import { Loader } from '@/components/Loading';
import {
  FloatingActionButton,
  HistoryItem,
  TableofContentsLeftRail,
} from '@/features/history';

import { useGetDeviceHistories } from './-query';

export const Route = createFileRoute('/_staff/devices/$id/_layout/history/')({
  component: DeviceHistoryTab,
});

function DeviceHistoryTab() {
  const { id } = useParams({ from: '/_staff/devices/$id/_layout/history/' });
  const { data, isPending } = useGetDeviceHistories(id);

  if (isPending || !data) {
    return <Loader />;
  }

  return (
    <HStack className="h-full p-10 gap-8">
      <nav className="sticky top-0 h-fit w-[240px]">
        <TableofContentsLeftRail
          historiesGroupByValidFrom={data.historiesGroupByValidFrom}
          basePath={`/devices/${id}/history`}
        />
      </nav>
      <VStack className="w-full relative">
        <FloatingActionButton disabled />
        <Spacer size={24} />
        <HistoryItem
          historiesGroupByValidFrom={data.historiesGroupByValidFrom}
        />
      </VStack>
    </HStack>
  );
}
